// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"90":"44105e89","151":"37e130cb","423":"f30e16a1","856":"5413b407","889":"4b4467f1"}[chunkId] + ".chunk.js";
};